module.exports = __webpack_public_path__ + "media/images/icons/reach-7712a7bdabcd0320272673f3002816df.svg";